const FLAG = "lyszt:debug";

function isEnabled() {
  if (typeof window === "undefined") return false;
  if (new URLSearchParams(window.location.search).has("debug")) {
    sessionStorage.setItem(FLAG, "1");
  }
  return sessionStorage.getItem(FLAG) === "1";
}

let panel;
let list;

function ensurePanel() {
  if (panel) return;

  panel = document.createElement("div");
  panel.style.cssText = [
    "position:fixed", "left:0", "right:0", "bottom:0", "z-index:2147483647",
    "max-height:45vh", "overflow:auto", "background:#1a1a1aee", "color:#f87171",
    "font:11px/1.5 monospace", "padding:8px 10px 12px", "border-top:2px solid #f87171",
    "white-space:pre-wrap", "word-break:break-word",
  ].join(";");

  const bar = document.createElement("div");
  bar.style.cssText = "display:flex;gap:12px;margin-bottom:6px;color:#fafafa";
  bar.append("DEBUG CONSOLE");

  const makeBtn = (label, onClick) => {
    const b = document.createElement("button");
    b.textContent = label;
    b.style.cssText = "background:#333;color:#fafafa;border:1px solid #555;padding:1px 8px;font:inherit;cursor:pointer";
    b.onclick = onClick;
    return b;
  };

  bar.append(
    makeBtn("copy", () => {
      navigator.clipboard?.writeText(list.innerText).catch(() => {});
    }),
    makeBtn("clear", () => { list.textContent = ""; }),
    makeBtn("off", () => {
      sessionStorage.removeItem(FLAG);
      panel.remove();
      panel = null;
    }),
  );

  list = document.createElement("div");
  panel.append(bar, list);
  document.body.append(panel);
}

function report(kind, value, extra) {
  try {
    ensurePanel();
    const entry = document.createElement("div");
    entry.style.cssText = "border-bottom:1px solid #444;padding:4px 0";
    const msg = value instanceof Error
      ? (value.stack || `${value.name}: ${value.message}`)
      : typeof value === "object" ? JSON.stringify(value) : String(value);
    entry.textContent = `[${kind}] ${msg}${extra ? `\n${extra}` : ""}`;
    list.append(entry);
    panel.scrollTop = panel.scrollHeight;
  } catch {
  }
}

export function initDebugOverlay() {
  if (!isEnabled()) return;

  window.addEventListener("error", (e) => {
    report("uncaught", e.error ?? e.message, e.filename ? `${e.filename}:${e.lineno}:${e.colno}` : "");
  });

  window.addEventListener("unhandledrejection", (e) => {
    report("unhandled rejection", e.reason);
  });

  const original = console.error;
  console.error = (...args) => {
    original.apply(console, args);
    report("console.error", args.length === 1 ? args[0] : args.map(String).join(" "));
  };

  if (document.body) ensurePanel();
  else document.addEventListener("DOMContentLoaded", () => ensurePanel());
}
